export const ErrorCodes = {
  WISH_LIST_DEVICE_ALREADY_EXISTS: "400.123.502",
  PAK_NOT_FOUND_EXCEPTION: "400.123.341",
  MULTIPLE_LOCATIONS_FOUND: "400.123.335",
  ORDER_NOT_FOUND: "400.123.404",
  MSISDN_REQUIRED: "400.123.424",
};

export default ErrorCodes;
